import { Link } from "react-router-dom";

interface CategoryEntriesProps {
  movieCount: number;
  tvCount: number;
}

export default function CategoryEntries({ movieCount, tvCount }: CategoryEntriesProps) {
  const entries = [
    {
      to: "/category/movies",
      title: "爱情电影",
      desc: "从经典到新片，收录动人光影里的爱情故事",
      count: movieCount,
      icon: "ri-film-line",
      tint: "bg-primary-50 text-primary-600",
    },
    {
      to: "/category/tv",
      title: "爱情电视剧",
      desc: "长篇细水长流的陪伴，追剧停不下来",
      count: tvCount,
      icon: "ri-tv-2-line",
      tint: "bg-accent-100 text-accent-700",
    },
  ];

  return (
    <section className="w-full px-4 md:px-8 -mt-12 md:-mt-16 relative z-30">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex items-center gap-4 md:gap-5 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 transition-colors cursor-pointer"
          >
            <span className={`w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-lg flex items-center justify-center text-2xl md:text-3xl ${entry.tint}`}>
              <i className={entry.icon}></i>
            </span>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {entry.title}
                </h3>
                <span className="text-xs text-foreground-500">{entry.count} 部</span>
              </div>
              <p className="mt-1 text-sm text-foreground-600 truncate">{entry.desc}</p>
            </div>
            <i className="ri-arrow-right-s-line ml-auto text-2xl text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}